/* eslint-disable import/prefer-default-export */

import { IntegrationCategoryParam, IntegrationCategory } from '../model'

export const integrationCategories: IntegrationCategory[] = [
  {
    label: 'Communications',
    value: IntegrationCategoryParam.COMMUNICATION,
  },
  {
    label: 'Product roadmapping',
    value: IntegrationCategoryParam.PRODUCT_ROADMAPPING,
  },
  {
    label: 'Project management',
    value: IntegrationCategoryParam.PROJECT_MANAGEMENT,
  },
  {
    label: 'CRM',
    value: IntegrationCategoryParam.CRM,
  },
  {
    label: 'Support',
    value: IntegrationCategoryParam.SUPPORT,
  },
  {
    label: 'Call transcription',
    value: IntegrationCategoryParam.CALL_TRANSCRIPTION,
  },
]
